// src/pages/Company/ContactPage.js
import React, { useState } from 'react';
import { Container, Typography, Paper, Box, Divider, Grid, TextField, Button, Alert, Link } from '@mui/material';
import { Email, Phone, LocationOn, Send } from '@mui/icons-material';

const RENGIGS = {
  green: '#2E7D32',
  lightGreen: '#4CAF50',
  lime: '#CDDC39',
  dark: '#1A2A3A',
  light: '#F8FAFC',
  border: '#E1E9F0',
  gradient: 'linear-gradient(135deg, #2E7D32 0%, #4CAF50 40%, #8BC34A 70%, #CDDC39 100%)',
};

const ContactPage = () => {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    // Mock submission – replace with actual API call
    if (formData.name && formData.email && formData.message) {
      setSubmitted(true);
      setFormData({ name: '', email: '', subject: '', message: '' });
    } else {
      setError('Please fill in all required fields.');
    }
  };

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, borderRadius: 3, border: `1px solid ${RENGIGS.border}` }}>
        <Typography variant="h3" sx={{ fontWeight: 900, color: RENGIGS.dark, mb: 1 }}>
          Contact Us
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Get in touch – we'd love to hear from you.
        </Typography>
        <Divider sx={{ mb: 4 }} />

        <Grid container spacing={4}>
          <Grid item xs={12} md={5}>
            <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 3 }}>
              Reach Out
            </Typography>
            <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
              <Email sx={{ color: RENGIGS.green }} />
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Email</Typography>
                <Link href="mailto:hello@rengigs.com" sx={{ color: RENGIGS.green, textDecoration: 'none' }}>hello@rengigs.com</Link>
              </Box>
            </Box>
            <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
              <Phone sx={{ color: RENGIGS.green }} />
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Phone</Typography>
                <Typography variant="body2">+234 803 830 4234</Typography>
              </Box>
            </Box>
            <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
              <LocationOn sx={{ color: RENGIGS.green }} />
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Office</Typography>
                <Typography variant="body2">Lagos, Nigeria (Remote-first)</Typography>
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>Support Hours</Typography>
            <Typography variant="body2">Monday – Friday: 8am – 5pm WAT</Typography>
            <Typography variant="body2">Weekend: Limited support (premium only)</Typography>
          </Grid>

          <Grid item xs={12} md={7}>
            <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 3 }}>
              Send a Message
            </Typography>
            {submitted && (
              <Alert severity="success" sx={{ mb: 3 }}>Thank you! We'll get back to you soon.</Alert>
            )}
            {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}
            <form onSubmit={handleSubmit}>
              <TextField fullWidth label="Name" name="name" value={formData.name} onChange={handleChange} required sx={{ mb: 2 }} />
              <TextField fullWidth label="Email" name="email" type="email" value={formData.email} onChange={handleChange} required sx={{ mb: 2 }} />
              <TextField fullWidth label="Subject" name="subject" value={formData.subject} onChange={handleChange} sx={{ mb: 2 }} />
              <TextField fullWidth label="Message" name="message" multiline rows={4} value={formData.message} onChange={handleChange} required sx={{ mb: 2 }} />
              <Button type="submit" variant="contained" startIcon={<Send />} sx={{ bgcolor: RENGIGS.green, '&:hover': { bgcolor: RENGIGS.lightGreen } }}>
                Send Message
              </Button>
            </form>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default ContactPage;